// 由 scripts/generate-docs-manifest.mjs 生成，请勿手工编辑。
export const sections = [
  {
    "id": "start",
    "zh": "开始使用",
    "en": "Get started"
  },
  {
    "id": "desktop",
    "zh": "桌面端功能",
    "en": "Desktop app"
  },
  {
    "id": "cli",
    "zh": "命令行",
    "en": "Command line"
  },
  {
    "id": "internals",
    "zh": "深入原理",
    "en": "Internals"
  }
]

export const docsIndex = [
  {
    "description": "An AI coding workbench that runs on your own machine. You pick the model; you approve every change.",
    "locale": "en",
    "navTitle": "What it is",
    "order": 0,
    "path": "/en/start",
    "section": "start",
    "slug": "en/start",
    "sourcePath": "docs/en/start/index.md",
    "title": "What Claude Code Heihei is"
  },
  {
    "description": "Installers for macOS, Windows, and Linux, plus what to do when the OS blocks them.",
    "locale": "en",
    "navTitle": "Install",
    "order": 1,
    "path": "/en/start/install",
    "section": "start",
    "slug": "en/start/install",
    "sourcePath": "docs/en/start/install.md",
    "title": "Download and install"
  },
  {
    "description": "Official accounts, third-party APIs, or a local model — pick one and be running in ten minutes.",
    "locale": "en",
    "navTitle": "Connect a model",
    "order": 2,
    "path": "/en/start/models",
    "section": "start",
    "slug": "en/start/models",
    "sourcePath": "docs/en/start/models.md",
    "title": "Connect a model"
  },
  {
    "description": "Pick a folder, set permissions, state a goal, watch it edit files, review the diff.",
    "locale": "en",
    "navTitle": "First session",
    "order": 3,
    "path": "/en/start/first-session",
    "section": "start",
    "slug": "en/start/first-session",
    "sourcePath": "docs/en/start/first-session.md",
    "title": "Run your first session"
  },
  {
    "description": "Organized by symptom — install failures, blank window, model 401s, stuck sessions, port conflicts, phone access.",
    "locale": "en",
    "navTitle": "Troubleshooting",
    "order": 4,
    "path": "/en/start/troubleshooting",
    "section": "start",
    "slug": "en/start/troubleshooting",
    "sourcePath": "docs/en/start/troubleshooting.md",
    "title": "Won't install, won't open, won't connect"
  },
  {
    "description": "Everything the desktop app can do, on one screen, with a link to each page.",
    "locale": "en",
    "navTitle": "Feature map",
    "order": 0,
    "path": "/en/desktop",
    "section": "desktop",
    "slug": "en/desktop",
    "sourcePath": "docs/en/desktop/index.md",
    "title": "Desktop feature map"
  },
  {
    "description": "A session from first question to reviewed diff, and which button to press when Claude asks.",
    "locale": "en",
    "navTitle": "Sessions",
    "order": 1,
    "path": "/en/desktop/sessions",
    "section": "desktop",
    "slug": "en/desktop/sessions",
    "sourcePath": "docs/en/desktop/sessions.md",
    "title": "Sessions, permissions, and review"
  },
  {
    "description": "The right-hand panel — see what changed, review the diff line by line, preview a page in-app.",
    "locale": "en",
    "navTitle": "Workspace",
    "order": 2,
    "path": "/en/desktop/workspace",
    "section": "desktop",
    "slug": "en/desktop/workspace",
    "sourcePath": "docs/en/desktop/workspace.md",
    "title": "Workspace"
  },
  {
    "description": "When to delegate, which agents ship built in, and how to write your own.",
    "locale": "en",
    "navTitle": "Subagents",
    "order": 3,
    "path": "/en/desktop/agents",
    "section": "desktop",
    "slug": "en/desktop/agents",
    "sourcePath": "docs/en/desktop/agents.md",
    "title": "Subagents"
  },
  {
    "description": "Run GGUF models directly on your own machine. No network, no API key.",
    "locale": "en",
    "navTitle": "Local models",
    "order": 4,
    "path": "/en/desktop/local-model",
    "section": "desktop",
    "slug": "en/desktop/local-model",
    "sourcePath": "docs/en/desktop/local-model.md",
    "title": "Local models"
  },
  {
    "description": "A skill is a ready-made procedure for Claude. What to check before installing one.",
    "locale": "en",
    "navTitle": "Skills",
    "order": 4,
    "path": "/en/desktop/skills",
    "section": "desktop",
    "slug": "en/desktop/skills",
    "sourcePath": "docs/en/desktop/skills.md",
    "title": "Skills and the Skills Market"
  },
  {
    "description": "Each settings tab — what it configures and when you'd need it.",
    "locale": "en",
    "navTitle": "Settings",
    "order": 6,
    "path": "/en/desktop/settings",
    "section": "desktop",
    "slug": "en/desktop/settings",
    "sourcePath": "docs/en/desktop/settings.md",
    "title": "Settings reference"
  },
  {
    "description": "Let Claude read your screen, move the mouse, and type into other apps.",
    "locale": "en",
    "navTitle": "Computer Use",
    "order": 7,
    "path": "/en/desktop/computer-use",
    "section": "desktop",
    "slug": "en/desktop/computer-use",
    "sourcePath": "docs/en/desktop/computer-use.md",
    "title": "Computer Use"
  },
  {
    "description": "Set up supervisor and worker sessions and use native tools to dispatch, report, review, and rework tasks.",
    "locale": "en",
    "navTitle": "Collaboration",
    "order": 9,
    "path": "/en/desktop/collaboration",
    "section": "desktop",
    "slug": "en/desktop/collaboration",
    "sourcePath": "docs/en/desktop/collaboration.md",
    "title": "Session collaboration and task ledger"
  },
  {
    "description": "Run the CLI from source - install dependencies, configure a provider, launch from any directory.",
    "locale": "en",
    "navTitle": "Install and Run",
    "order": 0,
    "path": "/en/cli",
    "section": "cli",
    "slug": "en/cli",
    "sourcePath": "docs/en/cli/index.md",
    "title": "Install and Run"
  },
  {
    "description": "Interactive sessions, --print headless mode, recovery mode, and common command-line flags.",
    "locale": "en",
    "navTitle": "Commands",
    "order": 1,
    "path": "/en/cli/reference",
    "section": "cli",
    "slug": "en/cli/reference",
    "sourcePath": "docs/en/cli/reference.md",
    "title": "Command Reference"
  },
  {
    "description": "Authentication, model, Azure, and local-runtime variables, plus the real precedence order.",
    "locale": "en",
    "navTitle": "Env Vars",
    "order": 2,
    "path": "/en/cli/env",
    "section": "cli",
    "slug": "en/cli/env",
    "sourcePath": "docs/en/cli/env.md",
    "title": "Environment Variables"
  },
  {
    "description": "How the five layers divide the work, how one message flows through them, and which page to read for the change you want to make.",
    "locale": "en",
    "navTitle": "Architecture",
    "order": 0,
    "path": "/en/internals",
    "section": "internals",
    "slug": "en/internals",
    "sourcePath": "docs/en/internals/index.md",
    "title": "Architecture Overview"
  },
  {
    "description": "Process boundaries between the Electron main process, server sidecar, and CLI subprocesses.",
    "locale": "en",
    "navTitle": "Desktop",
    "order": 1,
    "path": "/en/internals/desktop",
    "section": "internals",
    "slug": "en/internals/desktop",
    "sourcePath": "docs/en/internals/desktop.md",
    "title": "Desktop Architecture"
  },
  {
    "description": "Startup flags, access control, REST surface, and chat WebSocket of the local server.",
    "locale": "en",
    "navTitle": "Local Server",
    "order": 2,
    "path": "/en/internals/server",
    "section": "internals",
    "slug": "en/internals/server",
    "sourcePath": "docs/en/internals/server.md",
    "title": "Local Server and API"
  },
  {
    "description": "Responsibility boundaries across the CLI, server, desktop app, and docs site.",
    "locale": "en",
    "navTitle": "Structure",
    "order": 3,
    "path": "/en/internals/structure",
    "section": "internals",
    "slug": "en/internals/structure",
    "sourcePath": "docs/en/internals/structure.md",
    "title": "Project Structure"
  },
  {
    "description": "Built-in agents, spawn options, background tasks, Agent Teams, and custom agent definitions.",
    "locale": "en",
    "navTitle": "Multi-Agent Usage",
    "order": 4,
    "path": "/en/internals/agent",
    "section": "internals",
    "slug": "en/internals/agent",
    "sourcePath": "docs/en/internals/agent.md",
    "title": "Multi-Agent Usage Guide"
  },
  {
    "description": "Spawn paths, tool pool filtering, context passing, and the background task engine.",
    "locale": "en",
    "navTitle": "Multi-Agent Internals",
    "order": 5,
    "path": "/en/internals/agent-internals",
    "section": "internals",
    "slug": "en/internals/agent-internals",
    "sourcePath": "docs/en/internals/agent-internals.md",
    "title": "Multi-Agent Internals"
  },
  {
    "description": "The core agent loop, prompt engineering, tool system, and context compression, read from source.",
    "locale": "en",
    "navTitle": "Agent Framework",
    "order": 6,
    "path": "/en/internals/agent-framework",
    "section": "internals",
    "slug": "en/internals/agent-framework",
    "sourcePath": "docs/en/internals/agent-framework.md",
    "title": "Agent Framework Deep Dive"
  },
  {
    "description": "How the desktop app runs GGUF with the bundled llama.cpp, detects the GPU, and estimates KV cache VRAM.",
    "locale": "en",
    "navTitle": "Local models",
    "order": 6,
    "path": "/en/internals/local-model",
    "section": "internals",
    "slug": "en/internals/local-model",
    "sourcePath": "docs/en/internals/local-model.md",
    "title": "How local models work"
  },
  {
    "description": "Skill sources, definition format, invocation, execution context, and permission control.",
    "locale": "en",
    "navTitle": "Skills Usage",
    "order": 7,
    "path": "/en/internals/skills",
    "section": "internals",
    "slug": "en/internals/skills",
    "sourcePath": "docs/en/internals/skills.md",
    "title": "Skills Usage Guide"
  },
  {
    "description": "How skills are discovered, parsed, injected into conversations, and run in fork subagents.",
    "locale": "en",
    "navTitle": "Skills Internals",
    "order": 8,
    "path": "/en/internals/skills-internals",
    "section": "internals",
    "slug": "en/internals/skills-internals",
    "sourcePath": "docs/en/internals/skills-internals.md",
    "title": "Skills Internals"
  },
  {
    "description": "The four memory types, how saving is triggered, where memories live, and how to manage them.",
    "locale": "en",
    "navTitle": "Memory Usage",
    "order": 9,
    "path": "/en/internals/memory",
    "section": "internals",
    "slug": "en/internals/memory",
    "sourcePath": "docs/en/internals/memory.md",
    "title": "Memory System Usage Guide"
  },
  {
    "description": "Path resolution, prompt injection, auto-extraction, retrieval, and team memory sync.",
    "locale": "en",
    "navTitle": "Memory Internals",
    "order": 10,
    "path": "/en/internals/memory-internals",
    "section": "internals",
    "slug": "en/internals/memory-internals",
    "sourcePath": "docs/en/internals/memory-internals.md",
    "title": "Memory System Internals"
  },
  {
    "description": "The four-phase background pass that reviews recent sessions and prunes memories.",
    "locale": "en",
    "navTitle": "AutoDream",
    "order": 11,
    "path": "/en/internals/autodream",
    "section": "internals",
    "slug": "en/internals/autodream",
    "sourcePath": "docs/en/internals/autodream.md",
    "title": "AutoDream Memory Consolidation"
  },
  {
    "description": "Tool registration, coordinate mapping, authorization gates, the Python bridge, and safety limits.",
    "locale": "en",
    "navTitle": "Computer Use",
    "order": 12,
    "path": "/en/internals/computer-use",
    "section": "internals",
    "slug": "en/internals/computer-use",
    "sourcePath": "docs/en/internals/computer-use.md",
    "title": "Computer Use Architecture"
  },
  {
    "description": "Local setup, impact checks, quality gates, testing requirements, and the PR workflow.",
    "locale": "en",
    "navTitle": "Contributing",
    "order": 14,
    "path": "/en/internals/contributing",
    "section": "internals",
    "slug": "en/internals/contributing",
    "sourcePath": "docs/en/internals/contributing.md",
    "title": "Contributing and Quality Gates"
  },
  {
    "description": "跑在你自己电脑上的 AI 编程工作台：模型自己接，改动你审阅。",
    "locale": "zh",
    "navTitle": "这是什么",
    "order": 0,
    "path": "/start",
    "section": "start",
    "slug": "start",
    "sourcePath": "docs/start/index.md",
    "title": "Claude Code Heihei 是什么"
  },
  {
    "description": "macOS、Windows、Linux 三个平台的安装包，以及系统拦截时的处理办法。",
    "locale": "zh",
    "navTitle": "下载与安装",
    "order": 1,
    "path": "/start/install",
    "section": "start",
    "slug": "start/install",
    "sourcePath": "docs/start/install.md",
    "title": "下载与安装"
  },
  {
    "description": "官方账号、第三方 API、本地模型，三种接法任选一种，十分钟内跑起来。",
    "locale": "zh",
    "navTitle": "连接模型",
    "order": 2,
    "path": "/start/models",
    "section": "start",
    "slug": "start/models",
    "sourcePath": "docs/start/models.md",
    "title": "连接模型服务"
  },
  {
    "description": "选目录、定权限、说目标、看它改文件、逐行审阅——一轮完整流程。",
    "locale": "zh",
    "navTitle": "第一条会话",
    "order": 3,
    "path": "/start/first-session",
    "section": "start",
    "slug": "start/first-session",
    "sourcePath": "docs/start/first-session.md",
    "title": "跑通第一条会话"
  },
  {
    "description": "按症状查：安装失败、启动白屏、模型 401、会话卡住、端口冲突。",
    "locale": "zh",
    "navTitle": "排查问题",
    "order": 4,
    "path": "/start/troubleshooting",
    "section": "start",
    "slug": "start/troubleshooting",
    "sourcePath": "docs/start/troubleshooting.md",
    "title": "装不上 / 打不开 / 连不上"
  },
  {
    "description": "一屏看懂桌面端有哪些能力，以及每个功能该翻哪一篇。",
    "locale": "zh",
    "navTitle": "功能总览",
    "order": 0,
    "path": "/desktop",
    "section": "desktop",
    "slug": "desktop",
    "sourcePath": "docs/desktop/index.md",
    "title": "桌面端功能总览"
  },
  {
    "description": "一条会话从提问到审阅改动的全过程，以及权限弹窗该怎么点。",
    "locale": "zh",
    "navTitle": "会话与权限",
    "order": 1,
    "path": "/desktop/sessions",
    "section": "desktop",
    "slug": "desktop/sessions",
    "sourcePath": "docs/desktop/sessions.md",
    "title": "会话、权限与审阅"
  },
  {
    "description": "右侧工作区：看改了哪些文件、逐行评审 Diff、在应用里预览网页。",
    "locale": "zh",
    "navTitle": "工作区",
    "order": 2,
    "path": "/desktop/workspace",
    "section": "desktop",
    "slug": "desktop/workspace",
    "sourcePath": "docs/desktop/workspace.md",
    "title": "工作区"
  },
  {
    "description": "什么时候该派子 Agent、内置的有哪些、怎么捏一个自己的。",
    "locale": "zh",
    "navTitle": "子 Agent",
    "order": 3,
    "path": "/desktop/agents",
    "section": "desktop",
    "slug": "desktop/agents",
    "sourcePath": "docs/desktop/agents.md",
    "title": "子 Agent 与任务拆分"
  },
  {
    "description": "技能是给 Claude 的一套现成做法，从市场装之前要看清楚什么。",
    "locale": "zh",
    "navTitle": "技能",
    "order": 4,
    "path": "/desktop/skills",
    "section": "desktop",
    "slug": "desktop/skills",
    "sourcePath": "docs/desktop/skills.md",
    "title": "技能与技能市场"
  },
  {
    "description": "不联网、不要 API Key，直接在你自己电脑上跑 GGUF 大模型。",
    "locale": "zh",
    "navTitle": "本地模型",
    "order": 4,
    "path": "/desktop/local-model",
    "section": "desktop",
    "slug": "desktop/local-model",
    "sourcePath": "docs/desktop/local-model.md",
    "title": "本地模型"
  },
  {
    "description": "各设置分栏，每栏能配什么、什么时候需要动它。",
    "locale": "zh",
    "navTitle": "设置",
    "order": 6,
    "path": "/desktop/settings",
    "section": "desktop",
    "slug": "desktop/settings",
    "sourcePath": "docs/desktop/settings.md",
    "title": "设置速查"
  },
  {
    "description": "让 Claude 读屏幕、点鼠标、敲键盘，替你操作别的应用。",
    "locale": "zh",
    "navTitle": "Computer Use",
    "order": 7,
    "path": "/desktop/computer-use",
    "section": "desktop",
    "slug": "desktop/computer-use",
    "sourcePath": "docs/desktop/computer-use.md",
    "title": "Computer Use"
  },
  {
    "description": "设置主管与员工会话，使用原生工具派活、汇报、验收和返工。",
    "locale": "zh",
    "navTitle": "会话协作",
    "order": 9,
    "path": "/desktop/collaboration",
    "section": "desktop",
    "slug": "desktop/collaboration",
    "sourcePath": "docs/desktop/collaboration.md",
    "title": "会话协作与任务台账"
  },
  {
    "description": "从源码运行 CLI：安装依赖、配置模型服务、在任意目录启动。",
    "locale": "zh",
    "navTitle": "安装与启动",
    "order": 0,
    "path": "/cli",
    "section": "cli",
    "slug": "cli",
    "sourcePath": "docs/cli/index.md",
    "title": "安装与启动"
  },
  {
    "description": "交互式会话、--print 无头模式、恢复模式与常用命令行参数。",
    "locale": "zh",
    "navTitle": "命令参考",
    "order": 1,
    "path": "/cli/reference",
    "section": "cli",
    "slug": "cli/reference",
    "sourcePath": "docs/cli/reference.md",
    "title": "命令参考"
  },
  {
    "description": "认证、模型、Azure、本地运行相关的环境变量与实际生效顺序。",
    "locale": "zh",
    "navTitle": "环境变量",
    "order": 2,
    "path": "/cli/env",
    "section": "cli",
    "slug": "cli/env",
    "sourcePath": "docs/cli/env.md",
    "title": "环境变量"
  },
  {
    "description": "五层代码怎么分工，一条消息怎么流过它们，以及改动某块功能该从哪篇读起。",
    "locale": "zh",
    "navTitle": "架构总览",
    "order": 0,
    "path": "/internals",
    "section": "internals",
    "slug": "internals",
    "sourcePath": "docs/internals/index.md",
    "title": "架构总览"
  },
  {
    "description": "Electron 主进程、Server Sidecar 与 CLI 子进程的进程边界。",
    "locale": "zh",
    "navTitle": "桌面端架构",
    "order": 1,
    "path": "/internals/desktop",
    "section": "internals",
    "slug": "internals/desktop",
    "sourcePath": "docs/internals/desktop.md",
    "title": "桌面端架构"
  },
  {
    "description": "本地 Server 的启动参数、访问控制、REST 与 WebSocket 接口范围。",
    "locale": "zh",
    "navTitle": "本地 Server",
    "order": 2,
    "path": "/internals/server",
    "section": "internals",
    "slug": "internals/server",
    "sourcePath": "docs/internals/server.md",
    "title": "本地 Server 与 API"
  },
  {
    "description": "仓库的目录职责边界：CLI、Server、桌面端与文档站。",
    "locale": "zh",
    "navTitle": "项目结构",
    "order": 3,
    "path": "/internals/structure",
    "section": "internals",
    "slug": "internals/structure",
    "sourcePath": "docs/internals/structure.md",
    "title": "项目结构"
  },
  {
    "description": "内置 Agent、生成方式、后台任务、Agent Teams 与自定义 Agent 的写法。",
    "locale": "zh",
    "navTitle": "多 Agent 使用",
    "order": 4,
    "path": "/internals/agent",
    "section": "internals",
    "slug": "internals/agent",
    "sourcePath": "docs/internals/agent.md",
    "title": "多 Agent 使用指南"
  },
  {
    "description": "多 Agent 的生成路径、工具池过滤、上下文传递与后台任务引擎。",
    "locale": "zh",
    "navTitle": "多 Agent 实现",
    "order": 5,
    "path": "/internals/agent-internals",
    "section": "internals",
    "slug": "internals/agent-internals",
    "sourcePath": "docs/internals/agent-internals.md",
    "title": "多 Agent 实现原理"
  },
  {
    "description": "从源码视角拆解核心 Agent 循环、提示词工程、工具系统与上下文压缩。",
    "locale": "zh",
    "navTitle": "Agent 框架",
    "order": 6,
    "path": "/internals/agent-framework",
    "section": "internals",
    "slug": "internals/agent-framework",
    "sourcePath": "docs/internals/agent-framework.md",
    "title": "Agent 框架深度解析"
  },
  {
    "description": "桌面端怎么用内置 llama.cpp 跑 GGUF、怎么识别显卡、怎么估算 KV 缓存显存。",
    "locale": "zh",
    "navTitle": "本地模型原理",
    "order": 6,
    "path": "/internals/local-model",
    "section": "internals",
    "slug": "internals/local-model",
    "sourcePath": "docs/internals/local-model.md",
    "title": "本地模型原理"
  },
  {
    "description": "Skill 的六种来源、定义格式、调用方式、执行上下文与权限控制。",
    "locale": "zh",
    "navTitle": "Skills 使用",
    "order": 7,
    "path": "/internals/skills",
    "section": "internals",
    "slug": "internals/skills",
    "sourcePath": "docs/internals/skills.md",
    "title": "Skills 使用指南"
  },
  {
    "description": "Skill 如何被发现、解析、注入对话、在 fork 子 Agent 中执行。",
    "locale": "zh",
    "navTitle": "Skills 实现",
    "order": 8,
    "path": "/internals/skills-internals",
    "section": "internals",
    "slug": "internals/skills-internals",
    "sourcePath": "docs/internals/skills-internals.md",
    "title": "Skills 实现原理"
  },
  {
    "description": "四种记忆类型、触发保存的方式、存储位置与日常管理办法。",
    "locale": "zh",
    "navTitle": "记忆系统使用",
    "order": 9,
    "path": "/internals/memory",
    "section": "internals",
    "slug": "internals/memory",
    "sourcePath": "docs/internals/memory.md",
    "title": "记忆系统使用指南"
  },
  {
    "description": "路径解析、提示词注入、自动提取、智能检索与团队记忆同步。",
    "locale": "zh",
    "navTitle": "记忆系统实现",
    "order": 10,
    "path": "/internals/memory-internals",
    "section": "internals",
    "slug": "internals/memory-internals",
    "sourcePath": "docs/internals/memory-internals.md",
    "title": "记忆系统实现原理"
  },
  {
    "description": "后台静默回顾近期会话、整合并修剪记忆的四阶段流程与安全限制。",
    "locale": "zh",
    "navTitle": "AutoDream",
    "order": 11,
    "path": "/internals/autodream",
    "section": "internals",
    "slug": "internals/autodream",
    "sourcePath": "docs/internals/autodream.md",
    "title": "AutoDream 记忆整合"
  },
  {
    "description": "工具注册、坐标换算、授权检查、Python Bridge 与当前安全边界。",
    "locale": "zh",
    "navTitle": "Computer Use",
    "order": 12,
    "path": "/internals/computer-use",
    "section": "internals",
    "slug": "internals/computer-use",
    "sourcePath": "docs/internals/computer-use.md",
    "title": "Computer Use 架构"
  },
  {
    "description": "本地安装、影响面检查、质量门禁、测试要求与 PR 提交流程。",
    "locale": "zh",
    "navTitle": "参与贡献",
    "order": 14,
    "path": "/internals/contributing",
    "section": "internals",
    "slug": "internals/contributing",
    "sourcePath": "docs/internals/contributing.md",
    "title": "参与贡献与质量门禁"
  }
]

export const imageSizes = {"/images/01-overall-architecture.png":[2048,1143],"/images/02-request-lifecycle.png":[2048,1143],"/images/03-tool-system.png":[2048,1143],"/images/app/local-model-home.png":[2560,1368],"/images/app/welcome.png":[2560,1368],"/images/app-icon-dark.png":[1024,1024],"/images/app-icon-light.png":[1024,1024],"/images/app-icon.png":[1024,1024],"/images/banner.png":[2752,921],"/images/community/feishu-group-qr.png":[1372,1392],"/images/donate/alipay.jpg":[1080,1619],"/images/donate/logo-rounded.png":[2048,2048],"/images/donate/logo.png":[2048,2048],"/images/donate/wechat-pay.png":[1121,1527],"/images/donate/横版logo设计-rounded.png":[2848,1600],"/images/donate/横版logo设计.png":[2848,1600],"/images/logo-horizontal-dark.png":[2200,640],"/images/logo-horizontal.png":[1600,899],"/images/mascots/bubu.png":[160,160],"/images/mascots/dada.png":[160,160],"/images/mascots/huhu.png":[160,160],"/images/mascots/huihui.png":[160,160],"/images/v1.7/collab-tasks.png":[1440,900],"/images/v1.7/error-state.png":[1440,900],"/images/v1.7/sidebar.png":[1440,900]}

export const docsContent = {
  "/en/start": () => import('./content/en-start-index.js'),
  "/en/start/install": () => import('./content/en-start-install.js'),
  "/en/start/models": () => import('./content/en-start-models.js'),
  "/en/start/first-session": () => import('./content/en-start-first-session.js'),
  "/en/start/troubleshooting": () => import('./content/en-start-troubleshooting.js'),
  "/en/desktop": () => import('./content/en-desktop-index.js'),
  "/en/desktop/sessions": () => import('./content/en-desktop-sessions.js'),
  "/en/desktop/workspace": () => import('./content/en-desktop-workspace.js'),
  "/en/desktop/agents": () => import('./content/en-desktop-agents.js'),
  "/en/desktop/local-model": () => import('./content/en-desktop-local-model.js'),
  "/en/desktop/skills": () => import('./content/en-desktop-skills.js'),
  "/en/desktop/settings": () => import('./content/en-desktop-settings.js'),
  "/en/desktop/computer-use": () => import('./content/en-desktop-computer-use.js'),
  "/en/desktop/collaboration": () => import('./content/en-desktop-collaboration.js'),
  "/en/cli": () => import('./content/en-cli-index.js'),
  "/en/cli/reference": () => import('./content/en-cli-reference.js'),
  "/en/cli/env": () => import('./content/en-cli-env.js'),
  "/en/internals": () => import('./content/en-internals-index.js'),
  "/en/internals/desktop": () => import('./content/en-internals-desktop.js'),
  "/en/internals/server": () => import('./content/en-internals-server.js'),
  "/en/internals/structure": () => import('./content/en-internals-structure.js'),
  "/en/internals/agent": () => import('./content/en-internals-agent.js'),
  "/en/internals/agent-internals": () => import('./content/en-internals-agent-internals.js'),
  "/en/internals/agent-framework": () => import('./content/en-internals-agent-framework.js'),
  "/en/internals/local-model": () => import('./content/en-internals-local-model.js'),
  "/en/internals/skills": () => import('./content/en-internals-skills.js'),
  "/en/internals/skills-internals": () => import('./content/en-internals-skills-internals.js'),
  "/en/internals/memory": () => import('./content/en-internals-memory.js'),
  "/en/internals/memory-internals": () => import('./content/en-internals-memory-internals.js'),
  "/en/internals/autodream": () => import('./content/en-internals-autodream.js'),
  "/en/internals/computer-use": () => import('./content/en-internals-computer-use.js'),
  "/en/internals/contributing": () => import('./content/en-internals-contributing.js'),
  "/start": () => import('./content/start-index.js'),
  "/start/install": () => import('./content/start-install.js'),
  "/start/models": () => import('./content/start-models.js'),
  "/start/first-session": () => import('./content/start-first-session.js'),
  "/start/troubleshooting": () => import('./content/start-troubleshooting.js'),
  "/desktop": () => import('./content/desktop-index.js'),
  "/desktop/sessions": () => import('./content/desktop-sessions.js'),
  "/desktop/workspace": () => import('./content/desktop-workspace.js'),
  "/desktop/agents": () => import('./content/desktop-agents.js'),
  "/desktop/skills": () => import('./content/desktop-skills.js'),
  "/desktop/local-model": () => import('./content/desktop-local-model.js'),
  "/desktop/settings": () => import('./content/desktop-settings.js'),
  "/desktop/computer-use": () => import('./content/desktop-computer-use.js'),
  "/desktop/collaboration": () => import('./content/desktop-collaboration.js'),
  "/cli": () => import('./content/cli-index.js'),
  "/cli/reference": () => import('./content/cli-reference.js'),
  "/cli/env": () => import('./content/cli-env.js'),
  "/internals": () => import('./content/internals-index.js'),
  "/internals/desktop": () => import('./content/internals-desktop.js'),
  "/internals/server": () => import('./content/internals-server.js'),
  "/internals/structure": () => import('./content/internals-structure.js'),
  "/internals/agent": () => import('./content/internals-agent.js'),
  "/internals/agent-internals": () => import('./content/internals-agent-internals.js'),
  "/internals/agent-framework": () => import('./content/internals-agent-framework.js'),
  "/internals/local-model": () => import('./content/internals-local-model.js'),
  "/internals/skills": () => import('./content/internals-skills.js'),
  "/internals/skills-internals": () => import('./content/internals-skills-internals.js'),
  "/internals/memory": () => import('./content/internals-memory.js'),
  "/internals/memory-internals": () => import('./content/internals-memory-internals.js'),
  "/internals/autodream": () => import('./content/internals-autodream.js'),
  "/internals/computer-use": () => import('./content/internals-computer-use.js'),
  "/internals/contributing": () => import('./content/internals-contributing.js'),
}
